import styles from './index.module.sass';
import iconEmpty from 'assets/icon_empty_order.svg';

const EmptyState = ({ text, fullText, icon }) => {
  return (
    <div className={styles.empty}>
      <img src={icon || iconEmpty} alt="empty" />
      {fullText ? fullText : `目前沒有${text}`}
    </div>
  );
};

export default EmptyState;
